import { publicProfile } from './Public/publicProfile';
import {privateProfile} from "./Private/privateProfile";
import {private2Profile} from "./Private2/private2Profile";

export const profiles = [publicProfile, privateProfile, private2Profile];
